import React from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Link } from "react-router-dom";
import { FiSearch, FiMail, FiMenu, FiX } from "react-icons/fi";

function Header() {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    
    return (
        <header className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-br from-[#6366f1]/95 via-[#8b5cf6]/95 to-[#a855f7]/95 backdrop-blur-xl shadow-2xl border-b-4 border-[#ec4899]/50 shadow-[#6366f1]/40">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-20">
                    {/* Logo Section */}
                    <div 
                        className="flex items-center gap-3 cursor-pointer group" 
                        onClick={() => navigate('/')}
                    >
                        <div className="relative">
                            {/* Glowing halo effect - joyful cosmic */}
                            <div className="absolute inset-0 bg-gradient-to-r from-[#fbbf24]/40 via-[#ec4899]/30 to-[#3b82f6]/40 rounded-full blur-2xl opacity-60 animate-pulse"></div>
                            <div className="absolute inset-0 bg-[#8b5cf6]/30 rounded-full blur-xl"></div>
                            <img 
                                src="/joyloom.png" 
                                alt="JoyLoom" 
                                className="relative z-10 w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 object-contain transition-transform group-hover:scale-110 animate-bounce-joy" 
                                style={{
                                    filter: 'brightness(1.3) contrast(1.3) drop-shadow(0 0 20px rgba(251, 191, 36, 0.8)) drop-shadow(0 0 30px rgba(236, 72, 153, 0.6)) drop-shadow(0 0 40px rgba(59, 130, 246, 0.5))'
                                }}
                            />
                            <div className="absolute inset-0 bg-[#ec4899]/40 rounded-full blur-xl opacity-0 group-hover:opacity-80 transition-opacity -z-0"></div>
                        </div>
                        <div>
                            <span className="text-white font-bold text-xl tracking-tight drop-shadow-lg">JoyLoom Games</span>
                            <div className="h-1 w-0 bg-gradient-to-r from-[#fbbf24] via-[#ec4899] to-[#3b82f6] group-hover:w-full transition-all duration-300 shadow-lg shadow-[#8b5cf6]/60 rounded-full"></div>
                        </div>
                    </div>

                    {/* Desktop Navigation */}
                    <nav className="hidden lg:flex items-center gap-1">
                        <Link 
                            to="/" 
                            className="px-5 py-2.5 rounded-lg text-sm font-medium text-white hover:text-[#fef3c7] hover:bg-gradient-to-r hover:from-[#6366f1]/40 hover:via-[#ec4899]/40 hover:to-[#3b82f6]/40 hover:shadow-lg hover:shadow-[#8b5cf6]/50 transition-all duration-200 joy-hover"
                        >
                            Home
                        </Link>
                        <Link 
                            to="/about" 
                            className="px-5 py-2.5 rounded-lg text-sm font-medium text-white hover:text-[#fef3c7] hover:bg-gradient-to-r hover:from-[#6366f1]/40 hover:via-[#ec4899]/40 hover:to-[#3b82f6]/40 hover:shadow-lg hover:shadow-[#8b5cf6]/50 transition-all duration-200 joy-hover"
                        >
                            About
                        </Link>
                        <Link 
                            to="/contact" 
                            className="px-5 py-2.5 rounded-lg text-sm font-medium text-white hover:text-[#fef3c7] hover:bg-gradient-to-r hover:from-[#6366f1]/40 hover:via-[#ec4899]/40 hover:to-[#3b82f6]/40 hover:shadow-lg hover:shadow-[#8b5cf6]/50 transition-all duration-200 joy-hover"
                        >
                            Contact
                        </Link>
                        <Link 
                            to="/privacy" 
                            className="px-5 py-2.5 rounded-lg text-sm font-medium text-white hover:text-[#fef3c7] hover:bg-gradient-to-r hover:from-[#6366f1]/40 hover:via-[#ec4899]/40 hover:to-[#3b82f6]/40 hover:shadow-lg hover:shadow-[#8b5cf6]/50 transition-all duration-200 joy-hover"
                        >
                            Privacy
                        </Link>
                    </nav>

                    {/* Right Section - Search & Actions */}
                    <div className="flex items-center gap-3">
                        {/* Search Bar */}
                        <div className="hidden md:flex items-center bg-gradient-to-r from-[#6366f1]/30 via-[#8b5cf6]/30 to-[#ec4899]/30 rounded-full px-4 py-2 border-2 border-[#fbbf24]/40 hover:border-[#fbbf24]/60 hover:shadow-xl hover:shadow-[#8b5cf6]/40 transition-all backdrop-blur-sm">
                            <FiSearch className="text-white text-lg mr-2" />
                            <input 
                                placeholder="Search games..." 
                                className="bg-transparent outline-none text-sm text-white placeholder-white/70 w-32 focus:w-40 transition-all" 
                            />
                        </div>

                        {/* Contact Button */}
                        <button
                            onClick={() => navigate('/contact')}
                            className="hidden md:flex items-center gap-2 px-5 py-2.5 rounded-full bg-gradient-to-r from-[#fbbf24] via-[#f59e0b] to-[#ec4899] hover:from-[#fcd34d] hover:via-[#fbbf24] hover:to-[#f472b6] text-white font-bold text-sm shadow-xl shadow-[#8b5cf6]/40 hover:shadow-2xl hover:shadow-[#ec4899]/60 transition-all hover:scale-105 joy-hover"
                        >
                            <FiMail className="text-base" />
                            <span>Contact</span>
                        </button>

                        {/* Mobile Menu Button */}
                        <button 
                            className="lg:hidden p-2 rounded-lg text-white hover:bg-gradient-to-r hover:from-[#6366f1]/40 hover:via-[#ec4899]/40 hover:to-[#3b82f6]/40 hover:text-[#fef3c7] transition-colors" 
                            onClick={() => setOpen(v => !v)}
                            aria-label="Toggle menu"
                        >
                            {open ? <FiX className="w-6 h-6" /> : <FiMenu className="w-6 h-6" />}
                        </button>
                    </div>
                </div>

                {/* Mobile Navigation */}
                {open && (
                    <div className="lg:hidden pb-4 pt-2 border-t border-[#6b8e23]/20 animate-in slide-in-from-top">
                        <div className="flex flex-col gap-2 mt-2">
                            <Link 
                                to="/" 
                                onClick={() => setOpen(false)} 
                                className="px-4 py-3 rounded-lg text-white hover:text-[#fef3c7] hover:bg-gradient-to-r hover:from-[#6366f1]/40 hover:via-[#ec4899]/40 hover:to-[#3b82f6]/40 hover:shadow-lg hover:shadow-[#8b5cf6]/50 transition-all font-medium"
                            >
                                Home
                            </Link>
                            <Link 
                                to="/about" 
                                onClick={() => setOpen(false)} 
                                className="px-4 py-3 rounded-lg text-white hover:text-[#fef3c7] hover:bg-gradient-to-r hover:from-[#6366f1]/40 hover:via-[#ec4899]/40 hover:to-[#3b82f6]/40 hover:shadow-lg hover:shadow-[#8b5cf6]/50 transition-all font-medium"
                            >
                                About
                            </Link>
                            <Link 
                                to="/contact" 
                                onClick={() => setOpen(false)} 
                                className="px-4 py-3 rounded-lg text-white hover:text-[#fef3c7] hover:bg-gradient-to-r hover:from-[#6366f1]/40 hover:via-[#ec4899]/40 hover:to-[#3b82f6]/40 hover:shadow-lg hover:shadow-[#8b5cf6]/50 transition-all font-medium"
                            >
                                Contact
                            </Link>
                            <Link 
                                to="/privacy" 
                                onClick={() => setOpen(false)} 
                                className="px-4 py-3 rounded-lg text-white hover:text-[#fef3c7] hover:bg-gradient-to-r hover:from-[#6366f1]/40 hover:via-[#ec4899]/40 hover:to-[#3b82f6]/40 hover:shadow-lg hover:shadow-[#8b5cf6]/50 transition-all font-medium"
                            >
                                Privacy
                            </Link>
                            <div className="pt-2 mt-2 border-t border-[#fbbf24]/30">
                                <button
                                    onClick={() => {
                                        navigate('/contact');
                                        setOpen(false);
                                    }}
                                    className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-gradient-to-r from-[#fbbf24] via-[#f59e0b] to-[#ec4899] hover:from-[#fcd34d] hover:via-[#fbbf24] hover:to-[#f472b6] text-white font-bold shadow-xl shadow-[#8b5cf6]/40"
                                >
                                    <FiMail />
                                    <span>Contact Us</span>
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </header>
    );
}

export default Header;
